var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportProblemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3683_7841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 3.33333H12.5C12.5 2.44928 12.1488 1.60143 11.5237 0.976311C10.8986 0.35119 10.0507 0 9.16667 0L3.33333 0C2.44928 0 1.60143 0.35119 0.976311 0.976311C0.35119 1.60143 0 2.44928 0 3.33333L0 19.1667C0 19.3877 0.0877974 19.5996 0.244078 19.7559C0.400358 19.9122 0.61232 20 0.833333 20C1.05435 20 1.26631 19.9122 1.42259 19.7559C1.57887 19.5996 1.66667 19.3877 1.66667 19.1667V10.8333H8.33333C8.33333 11.7174 8.68452 12.5652 9.30964 13.1904C9.93476 13.8155 10.7826 14.1667 11.6667 14.1667H16.6667C17.5507 14.1667 18.3986 13.8155 19.0237 13.1904C19.6488 12.5652 20 11.7174 20 10.8333V6.66667C20 5.78261 19.6488 4.93476 19.0237 4.30964C18.3986 3.68452 17.5507 3.33333 16.6667 3.33333ZM1.66667 9.16667V3.33333C1.66667 2.89131 1.84226 2.46738 2.15482 2.15482C2.46738 1.84226 2.89131 1.66667 3.33333 1.66667H9.16667C9.60869 1.66667 10.0326 1.84226 10.3452 2.15482C10.6577 2.46738 10.8333 2.89131 10.8333 3.33333V7.5C10.8333 7.94203 10.6577 8.36595 10.3452 8.67851C10.0326 8.99107 9.60869 9.16667 9.16667 9.16667H1.66667ZM18.3333 10.8333C18.3333 11.2754 18.1577 11.6993 17.8452 12.0118C17.5326 12.3244 17.1087 12.5 16.6667 12.5H11.6667C11.2246 12.5 10.8007 12.3244 10.4882 12.0118C10.1756 11.6993 10 11.2754 10 10.8333V10.715C10.7135 10.5308 11.3458 10.1154 11.7981 9.53369C12.2504 8.95201 12.4972 8.23685 12.5 7.5V5H16.6667C17.1087 5 17.5326 5.17559 17.8452 5.48816C18.1577 5.80072 18.3333 6.22464 18.3333 6.66667V10.8333Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3683_7841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportProblemIcon);
export default __webpack_public_path__ + "static/media/ReportProblemIcon.c1714874.svg";
export { ForwardRef as ReactComponent };